'use strict';
import Validator from '../checkout/validator';
import $ from 'jquery';
import { inputFilteringEvents, showValidationErrors } from '../util/form';
import { validateForm } from '../api/validation';
import serialize from 'form-serialize';
import util from './';
import Promise from 'bluebird';

const submitForm = (formSelector) => {
	const $form = $(formSelector);
	const showErrors = showValidationErrors($form);
	const { orderId, validation } = $form.data();
	const loader = util.addFormLoader($form, {align: 'before'});
	const data = {
		fields: serialize($form.get(0), {hash: true}),
		orderId
	};
	if ($form.data('admin-form')) {
		data.isAdminForm = 1;
	}

	const validationPromise = validation ? validateForm(validation, data) : Promise.resolve({ pass: true });
	validationPromise
		.then(res => {
			if (res.errors && res.errors.length) {
				showErrors(res.errors);
				const $firstAlert = $form.find('.validation-alert').first();
				if ($firstAlert.length) {
					$('html,body').animate({scrollTop: $firstAlert.offset().top - 20});
				}
			} else if (res.pass) {
				$form.trigger('submit');
			}
		})
		.catch(console.error)
		.finally(() => loader.done());
}

export const formValidationEvents = (formElem) => {
	const $form = $(formElem);
	const validator = new Validator($form);

	validator.isAdminForm = $form.data('admin-form') === 1 || $form.data('admin-form') === '1';

	const showErrors = showValidationErrors($form);

	$form.on('focusout change', e => {
		validator.validateField($(e.target));
	});

	validator.on('success', $input => {
		$input.removeClass('validation-error')
			.closest('.field')
			.find('.validation-error-msg')
			.remove();
	});

	validator.on('fail', ($input, errors) => {
		showErrors(errors);
	});

	$form.find('.show-password').on('click', (e) => {
		const $this = $(e.target);
		const $passwordField = $this.siblings('input').first();
		if ($passwordField.attr('type') === 'password') {
			$passwordField.attr('type', 'text');
			$this.text('Piilota');
		} else {
			$passwordField.attr('type', 'password');
			$this.text('Näytä');
		}
	});

	$form.find('.change-email').on('click', (e) => {
		const $thisForm = $('.form-new-email');
		const $newEmailContainer = $thisForm.find('.change-email__new');
		const $newEmailField = $newEmailContainer.find('input').first();

		if ($newEmailField.attr('type') === 'input') {
			$newEmailField.prop('disabled', false).removeClass('disabled');
			$thisForm.addClass('active-email-change');
			$thisForm.find('input[type=submit]').prop('disabled', true);

			// Hide old email field
			$thisForm.find('.change-email__old').hide().find('input');

			// Show new
			$newEmailContainer.show();
		}
	});

	$form.find('#newemail').on('focus', (e) => {
		const $thisForm = $('.form-new-email');

		$thisForm.find('input[type=submit]')
			.prop('disabled', false)
			.removeClass('disabled');

	});

	// validate phone number if phone contact is selected
	validator.addConditionalRule('phone', 'required', () => {
		return $('#phoneSelected').is(':checked');
	});

}

export default (API) => {
	API.log('INIT formValidation');

	API.formValidation = (selector = '.v4-form') => {
		$(selector).each(function() {
			const $form = $(this);

			inputFilteringEvents($form);
			formValidationEvents($form);

			const { validation } = $form.data();
			if (validation) {
				$form.on('click', 'input[type="submit"]', e => {
					e.preventDefault();
					submitForm($form);
				});
			}
		});
	}

	API.submitForm = submitForm;
}
